"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCheckinManagerAppLink = exports.getPlayStoreUrl = exports.getAppStoreUrl = void 0;
const country_1 = require("../internationalization/enums/country");
const APP_STORE_BASE_URL = "https://apps.apple.com";
const APP_STORE_APP_ID = "id1668842941";
const PLAY_STORE_APP_ID = "com.zeffy.taptopay";
const PLAY_STORE_BASE_URL = "https://play.google.com/store/apps/details";
/**
 * Generate Apple App Store URL for the Zeffy mobile app (Tap to Pay)
 * @param country - Organization country
 * @returns App Store URL
 */
const getAppStoreUrl = (country) => {
    const countryCode = country ? country_1.ORGANIZATION_COUNTRY_MAP[country].appleStoreCountry : country_1.DEFAULT_APPLE_STORE_COUNTRY;
    return `${APP_STORE_BASE_URL}/${countryCode}/app/zeffy-tap-to-pay/${APP_STORE_APP_ID}`;
};
exports.getAppStoreUrl = getAppStoreUrl;
/**
 * Generate Google Play Store URL for the Zeffy mobile app (Tap to Pay)
 * @returns Play Store URL
 */
const getPlayStoreUrl = () => {
    return `${PLAY_STORE_BASE_URL}?id=${PLAY_STORE_APP_ID}`;
};
exports.getPlayStoreUrl = getPlayStoreUrl;
const getCheckinManagerAppLink = ({ frontendUrl, ticketingId }) => `${frontendUrl}/CheckinManager/${ticketingId}`;
exports.getCheckinManagerAppLink = getCheckinManagerAppLink;
